// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-avatar[data-v-d364513c]{width:62px;height:62px;border-radius:50%;background:#edf4ff;color:#4b81c8;margin:0 auto;display:flex;align-items:center;justify-content:center;font-size:22px;overflow:hidden}.user-avatar img[data-v-d364513c]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = exports;
